import { render, staticRenderFns } from "./order-confirmation-template-selector.vue?vue&type=template&id=3f20bf40&scoped=true&"
import script from "./order-confirmation-template-selector.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-template-selector.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-template-selector.vue?vue&type=style&index=0&id=3f20bf40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20bf40",
  null
  
)

export default component.exports